export default __webpack_public_path__ + "static/media/student (2).70ede115.svg";